// Former page-level `middleware({ redirect })` of pages/search/index.vue —
// that page is gone, /search matches the pages/search.vue parent route and the
// products tab is the default child.
// Matching by route name, not by path, so the locale-prefixed variants
// (/de/search, /ru/search, ...) are covered as well.
export default defineNuxtRouteMiddleware((to) => {
  const name = String(to.name ?? '');
  const isSearchIndex = name === 'search' || name.startsWith('search___');

  if (!isSearchIndex) return undefined;

  const localePath = useLocalePath();
  return navigateTo(localePath('/search/products/'));
});
